import { VectorMap } from "@react-jvectormap/core";
import { worldMill } from "@react-jvectormap/world";
import React from "react";

function WorldMap() {
	return (
		<div className="map-container">
			<VectorMap
				zoomOnScroll={false}
				map={worldMill}
				backgroundColor="transparent"
				regionStyle={{
					initial: {
						fill: "#21a2a0",
						"fill-opacity": 1,
						stroke: "#ffffff",
						"stroke-width": 0.5,
						"stroke-opacity": 1
					},
					hover: {
						fill: "#1a8280",
						"fill-opacity": 1
					}
				}}
				markerStyle={{ 
					initial: { 
						fill: "#ffffff", 
						stroke: "#21a2a0",
						"stroke-width": 2,
						r: 5
					} 
				}}
				markerLabelStyle={{
					initial: {
						"font-size": "12px",
						"font-family": "Arial",
						"font-weight": "bold",
						"fill": "#ffffff"
					},
				}}
				markers={[
					{ latLng: [1.3521, 103.8198], name: "Singapore" },
					{ latLng: [40.7128, -74.0060], name: "New York, USA" },
					{ latLng: [50.1109, 8.6821], name: "Frankfurt, Germany" },
					{ latLng: [28.6139, 77.2090], name: "Delhi, India" },
				]}
			/>
		</div>
	);
}

export default WorldMap;
